import { Flex, Skeleton } from 'antd';
import React from 'react';

import { SalesFunnelColumnComponent } from '@app/components';
import { PREFIX } from '@app/constants';

import { useViewSalesFunnelEffects } from '@pages/SalesFunnels/ViewSalesFunnel/hooks/useViewSalesFunnelEffects';

import '@pages/SalesFunnels/ViewSalesFunnel/styles/ViewSalesFunnel.desktop.scss';

export const ViewSalesFunnel: React.FC = () => {
  const { currentSalesFunnelStages, isStageFunnelLoading } =
    useViewSalesFunnelEffects();

  if (isStageFunnelLoading) {
    return <Skeleton />;
  }

  return (
    <div className={`${PREFIX}view-sales-funnel`}>
      <Flex gap="middle" className="flex-component">
        ё1
        {currentSalesFunnelStages.map((item) => (
          <SalesFunnelColumnComponent
            data={item}
            isEditPageComponent={false}
            key={item.Id}
            robotsWithProgress={[]}
          />
        ))}
        123
      </Flex>
    </div>
  );
};
